module.exports = __webpack_public_path__ + "img/gy.14c971f6.png";